import SmoothScroll from 'smoothscroll-for-websites/SmoothScroll';
import AOS from 'aos';

$(function() {
    new SmoothScroll({
        // Scrolling Core
        animationTime: 400, stepSize: 80,

        // Acceleration
        accelerationDelta: 50, accelerationMax: 3,

        // Keyboard Settings
        keyboardSupport: true, arrowScroll: 50,

        // Pulse (less tweakable)
        // ratio of "tail" to "acceleration"
        pulseAlgorithm: true,
        pulseScale: 4,
        pulseNormalize: 1,

        // Other
        touchpadSupport: false, // ignore touchpad by default
        fixedBackground: true,
        excluded: ''
    });

    setTimeout(() => {
        AOS.init({
            once: true,
            duration: 700,
            delay: 300
        });
    }, 100);
});